// extracted by mini-css-extract-plugin
module.exports = {"title":"title__title___2i6dw"};